import { type FC } from "react";

export const ManualPeriodIndicator: FC = () => (
	<sup data-testid="manual-period-indicator" title="Manual Period" className="ml-0.5">
		M
	</sup>
);
